import { pdfjs } from 'react-pdf';

export function setupPdfWorker() {
  const url = new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).toString();

  pdfjs.GlobalWorkerOptions.workerSrc = url;
}
